(function ($) {
    let BUILDING_BLOCKS = {};

    class GameLogic {

        constructor() {
            this.currentBlockType = false,
                this.currentBlockID = false;

            // only call initialize function on homepage / main game
            if ($('body').hasClass('homepage') || $('body').hasClass('home')) {
                this._initialize();

								// load storage
								const storage = new BD_Storage(); // see bd-storage.js
								storage.load();
								window.bdStorage = storage;
            }
        }

        _initialize() {
            const _this = this;

            /* Prepare building block data */
            bdapi.post('game/game-data')
                .then((response) => {
                    const status = response.status;

                    if (status !== 200) { return; }

                    const data = response.data.data;

                    BUILDING_BLOCKS = data.building_blocks;
                    BD_Variable.set(data.answer_variables);
										BD_SequenceHistory.set(data.history);

                    _this.currentBlockID = data.current_block_id;
                    _this.currentBlockType = data.current_block_type;

                    _this._render();
                }).catch((error) => {
                    // alert('Error : Failed to fetch game data!');
                });

        } //-- END _initialize()

        _render() {
            const currentBlock = bdjs.getBlock(this.currentBlockType);

            if (currentBlock) {
                const blockData = this._getBlockData(this.currentBlockID);

                currentBlock._setData(blockData.data);
                currentBlock.init();

                //Hide loading screen
                if (!currentBlock._serverSide) {
                    bdjs.hideLoading();
                }
            } else {
                console.error("Component : Can't find component " + this.currentBlockType);
            }
        } //-- END _render()

        _getBlockData(blockID, blockType) {
            let _data = {};
            let _type = false;

            if (typeof BUILDING_BLOCKS[blockID] !== 'undefined') {
                const theBlockData = BUILDING_BLOCKS[blockID];
                _data = theBlockData;
                _type = theBlockData.type;
            }

            if (blockType === 'end') {
                _data = {};
                _type = 'end';
            }

						_data = BD_Variable.resolveBlock(_data)

            return {
                type: _type,
                data: _data,
            };

        } //-- EMD _getBlcokData()

        getCurrentBlockID() {
            return this.currentBlockID;
        }

        getCurrentBlockType() {
            return this.currentBlockType;
        }

				goBack(blockID) {
					const block = BUILDING_BLOCKS[blockID]
					const type = block.type
					const skipHistory = true
					this.goTo(blockID, type, skipHistory)
				}

        goTo(blockID, blockType, skipHistory = false) {
            const destinationBlockData = this._getBlockData(blockID, blockType);
            const destinationBlock = bdjs.getBlock(destinationBlockData.type);

						var history = {
							prev: this.getCurrentBlockID(),
							next: parseInt(blockID)
						}

						if(!skipHistory) {
							BD_SequenceHistory.data[history.next] = history
						}

            if (destinationBlock) {

                bdjs.showLoading(() => {

                    const _prevBlock = bdjs.getBlock(this.currentBlockType);
                    if (_prevBlock) _prevBlock.destroy();

                    destinationBlock._setData(destinationBlockData.data);
                    destinationBlock.init();

                    this.currentBlockID = blockID;
                    this.currentBlockType = destinationBlockData.type;

                    //Hide loading screen
                    if (!destinationBlock._serverSide) {
                        bdjs.hideLoading();
                    }
                });
            } else {
                console.error("Component : Can't find block type " + destinationBlockData.type);
            }
        }

        goToDefaultNextBlock() {
            const blockID = this.getCurrentBlockID();

            bdjs.showLoading(() => {

                bdapi.post('game/go-next-sequence', {
                    current_block_id: blockID
                })
                    .then((res) => {
                        const resData = res.data;
                        const data = resData.data;

                        if (data) {
                            BD_GAME_LOGIC.goTo(data.next_sequence, data.next_sequence_type);
                            return false;
                        }

                    }).catch((error) => {
                        alert('Error : Failed to fetch data from server!');
                    });

            });
        }
    }

    window.BD_GAME_LOGIC = new GameLogic();
})(jQuery);
